"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _HBSidePanel = _interopRequireDefault(require("./HBSidePanel"));
var _HBSidePanel2 = require("./HBSidePanel.consts");
var HBSidePanelHeader = function HBSidePanelHeader(_ref) {
  var className = _ref.className,
    extraControls = _ref.extraControls,
    leftSection = _ref.leftSection,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'side-panel-header' : _ref$testId;
  return /*#__PURE__*/_react["default"].createElement(HeaderContainer, {
    className: className,
    "data-testid": testId
  }, /*#__PURE__*/_react["default"].createElement(LeftSection, null, leftSection), extraControls && /*#__PURE__*/_react["default"].createElement(MiddleSection, null, extraControls), /*#__PURE__*/_react["default"].createElement(RightSection, null, /*#__PURE__*/_react["default"].createElement(_HBSidePanel["default"].CloseButton, null)));
};
var _default = exports["default"] = HBSidePanelHeader; // -------------------------------- Styles -------------------------------- //
var HeaderContainer = _styledComponents["default"].header.withConfig({
  displayName: "HBSidePanelHeader__HeaderContainer",
  componentId: "sc-32tgkf-0"
})(["", ";justify-content:space-between;height:62px;padding:16px;background-color:", ";border-bottom:1px solid ", ";.", " &{border-bottom-color:", ";}"], _mixins.flexCenterVertical, _colors["default"].white, _colors["default"].transparent, _HBSidePanel2.SIDE_PANEL_SCROLLED_CLASS, _colors["default"].neutral200);
var LeftSection = _styledComponents["default"].div.withConfig({
  displayName: "HBSidePanelHeader__LeftSection",
  componentId: "sc-32tgkf-1"
})(["", ";gap:12px;min-width:30px;padding-right:16px;"], _mixins.flexCenterVertical);
var MiddleSection = _styledComponents["default"].div.withConfig({
  displayName: "HBSidePanelHeader__MiddleSection",
  componentId: "sc-32tgkf-2"
})(["flex:1;", ";min-width:0;padding-left:16px;padding-right:8px;justify-content:end;"], _mixins.flexCenterVertical);
var RightSection = _styledComponents["default"].div.withConfig({
  displayName: "HBSidePanelHeader__RightSection",
  componentId: "sc-32tgkf-3"
})(["", ";padding-left:8px;border-left:1px solid ", ";"], _mixins.flexCenterVertical, _colors["default"].neutral300);
//# sourceMappingURL=HBSidePanelHeader.js.map